<template>
  <!-- CAPITAL LABEL -->
  <span class="capital-label" :class="{ 'secondary': isSecondaryColor }">{{ label }}</span>
  <!-- CAPITAL LABEL -->
</template>

<script setup>
  const props = defineProps([
    'label',
    'isSecondaryColor',
  ])
</script>

<style scoped>
  .capital-label {
    font-family: 'Open Sans', sans-serif;
  }
  .capital-label.secondary {
    font-family: 'Myriad-Pro', sans-serif;

    color: #5a5d67;
    letter-spacing: -0.2px;
    background-color: #c014430d;
  }
</style>
